import { gql } from "@apollo/client";

export const UPDATE_SESSION_RECORD = gql`mutation updateSessionRecordStatus($cId: UUID!, $sId: UUID!, $sjId: UUID!,$isRecordStart:Boolean!,$recordStarttime:Datetime) {
    updateSessionRecordStatus(
      input: {pCId: $cId, pIsRecordStsrt: $isRecordStart, pReocrdStartTime: $recordStarttime, pSessionId: $sId, pSubjectId: $sjId}
    ) {
      clientMutationId
    }
}`;

//Mutation to update the liveclass replica meeting ids
export const UPDATE_LIVECLASS_REPLICA_MEETING_IDS = gql`
mutation UpdateSessionReplicaMeetingIds(
  $cId: UUID!
  $sjId: UUID!
  $sessionId: UUID!
  $replicaMeetingIds: [String]!
) {
  updateSessionReplicaMeetingIds(
    input: {
      pCId: $cId
      pSubjectId: $sjId
      pSessionId: $sessionId
      pReplicaMeetingIds: $replicaMeetingIds
    }
  ) {
    clientMutationId
  }
}
`;

//Mutation to update the liveclass host Id and original host id
export const UPDATE_LIVECLASS_HOST_ID = gql`
mutation UpdateSessionHost($input: UpdateSessionHostInput!) {
  updateSessionHost(input: $input) {
    clientMutationId
  }
}
`;

//Mutation to update the liveclass host Id and original host id
export const UPDATE_LIVECLASS_MEET_CHAT_STATUS = gql`
mutation UpdateLiveClassMeetingChatStatus(
  $cId: UUID!
  $sjId: UUID!
  $sessionId: UUID!
  $showChat: Boolean!
) {
  updateSessionShowChat(
    input: {
      pCId: $cId
      pSubjectId: $sjId
      pSessionId: $sessionId
      pShowChat: $showChat
    }
  ) {
    clientMutationId
  }
}
`;

// Mutation to update liveclass meeting ID with media pipeline details
export const UPDATE_LIVECLASS_MEDIA_PIPELINE_INFO = gql`
mutation UpdateSessionMediaInfo(
  $cId: UUID!
  $sjId: UUID!
  $sessionId: UUID!
  $mediaPipelineArn: String
  $mediaPipelineId: String
  $sourceDestinationArn: String
) {
  updateSessionMediaInfo(
    input: {
      pCId: $cId
      pSubjectId: $sjId
      pSessionId: $sessionId
      pMediaPipelineArn: $mediaPipelineArn
      pMediaPipelineId: $mediaPipelineId
      pSourceDestinationArn: $sourceDestinationArn
    }
  ) {
    clientMutationId
  }
}
`;

// Mutation to update PTA meeting ID with media pipeline details
export const UPDATE_PTA_MEDIA_PIPELINE_INFO = gql`
mutation UpdatePtaMeetingMediaInfo($meetingPatch: MeetingPatch!, $mId: UUID!) {
  editPtaMeeting(input: { meetingPatch: $meetingPatch, mId: $mId })
}
`;

export const ADD_SESSION_PARTICIPANTS = gql`
  mutation AddSessionParticipant(
    $cId: UUID!
    $sId: UUID!
    $sjId: UUID!
    $participantId: String!
  ) {
    addSessionParticipant(
      input: {
        pCId: $cId
        pSessionId: $sId
        pSubjectId: $sjId
        pParticipantId: $participantId
      }
    ) {
      clientMutationId
    }
  }
`;

export const DELETE_SESSION_PARTICIPANT = gql`
  mutation DeleteSessionParticipant(
    $cId: UUID!
    $sId: UUID!
    $sjId: UUID!
    $participantId: String!
  ) {
    deleteSessionParticipant(
      input: {
        clientMutationId: ""
        pCId: $cId
        pSessionId: $sId
        pSubjectId: $sjId
        pParticipantId: $participantId
      }
    ) {
      clientMutationId
    }
  }
`;
